export default "/images/f5d2eea14527a0c04c210eb554090ca0.avif";